import { createContext } from "react";

export type AppChromeMode = "focused" | "operational" | "retailer";

export const AppChromeContext = createContext<{
  mode: AppChromeMode;
  setMode: (mode: AppChromeMode) => void;
} | null>(null);
